import { Component, inject, Output, EventEmitter } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-button-country',
  templateUrl: 'button-country.component.html',
  styleUrl: 'button-country.component.css',
  imports: [MatListModule, MatIconModule],
  standalone: true
})
export class ButtonCountry {
  @Output() languageChanged = new EventEmitter<string>();
  private translate = inject(TranslateService);

  constructor() {
    // Garantir que os idiomas estejam disponíveis
    this.translate.addLangs(['pt', 'en', 'es']);
    this.translate.setFallbackLang('en');
  }

  changeLanguage(lang: string) {
    console.log('Mudando idioma para:', lang);
    this.translate.use(lang);
    
    // Salvar no localStorage apenas se estiver no browser
    if (typeof window !== 'undefined' && window.localStorage) {
      localStorage.setItem('language', lang);
    }
    
    console.log('Idioma atual:', this.translate.currentLang);
    this.languageChanged.emit(lang);
    
    // Recarregar a página após mudança de idioma
    if (typeof window !== 'undefined') {
      window.location.reload();
    }
  }

  getCurrentLanguage(): string {
    return this.translate.currentLang || 'en';
  }
}
